import { KeyValue } from "@angular/common";
import { CulturalActivity } from "@common/ADAPT.Common.Model/organisation/cultural-activity";
import { CulturalActivityStatus } from "@common/ADAPT.Common.Model/organisation/cultural-activity-status";
import { Item } from "@common/ADAPT.Common.Model/organisation/item";
import { Meeting } from "@common/ADAPT.Common.Model/organisation/meeting";
import { Objective } from "@common/ADAPT.Common.Model/organisation/objective";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { IAdaptLinkObject } from "@common/route/route.service";
import { ActivityType, ICulturalActivityTypeMetadata } from "@org-common/lib/cultural-activity/cultural-activity-type-metadata";
import { IMeetingTeamGroup } from "@org-common/lib/meetings/meetings.service";
import { IObjectiveTeamGroup } from "@org-common/lib/objectives/objectives.service";

export type IActivityEntityType =
    CulturalActivity
    | Item
    | Objective
    | Team          // used for vision
    | IObjectiveTeamGroup
    | Meeting
    | IMeetingTeamGroup;

export type ICulturalActivityStatusGroup = {
    [key in ActivityType]: IActivityEntityType[];
}

export type ICulturalActivitiesGroupedByStatusAndType = {
    [key in CulturalActivityStatus]: ICulturalActivityStatusGroup;
}

export type ICulturalActivityStatusGroupKeyValueRecord = KeyValue<ActivityType, IActivityEntityType[]>;

export type IActivitySection = Pick<ICulturalActivityTypeMetadata, "title" | "colourAccent" | "route$" | "routeRequiresTeamId">;

export interface IActivityStatusSection extends IActivitySection {
    group: keyof ICulturalActivitiesGroupedByStatusAndType;
    displayedCount: number;
    totalCount: number;
}

export enum ActivityFilterParamKeys {
    DueWithin = "dueWithin",
    HiddenTypes = "hiddenTypes",
    HiddenStatuses = "hiddenStatuses",
}

export type IActivityGroupStatuses<T = IActivityEntityType> = Record<CulturalActivityStatus, T[]>;

export interface IActivityGroup<T = IActivityEntityType> extends IActivityGroupStatuses<T> {
    allItems: T[],
    displayedCount: number,
    totalCount: number,
    totalCountByStatus: IActivitiesGroupedByStatusCounts,
}

export type IActivitiesGroupedByActivityType = Record<ActivityType, IActivityGroup>;
export type IActivitiesGroupedByStatusCounts = Record<CulturalActivityStatus, number>;

export enum ActivityPage {
    Pathway = "pathway",
    Status = "status",
    Activity = "activity",
    Calendar = "calendar",
}

export interface ICalendarCulturalActivity {
    activity?: IActivityEntityType;
    activityKey?: string;
    title?: string;
    startDate?: Date;
    endDate?: Date;
    isAllDay: boolean;
    type: ActivityType;
    metadata: ICulturalActivityTypeMetadata;
    completed: boolean;
}

export type IActivityRoutes = {
    [key in ActivityType]?: IAdaptLinkObject;
}
